/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface DialpadUser
 */
export interface DialpadUser {
  /**
   *
   * @type {string}
   * @memberof DialpadUser
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof DialpadUser
   */
  companyKey?: string;
  /**
   *
   * @type {Array<any>}
   * @memberof DialpadUser
   */
  csrPermissions?: Array<any>;
  /**
   *
   * @type {number}
   * @memberof DialpadUser
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof DialpadUser
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string | null}
   * @memberof DialpadUser
   */
  dialpadApiKey?: string | null;
  /**
   *
   * @type {number | null}
   * @memberof DialpadUser
   */
  dialpadUserId?: number | null;
  /**
   *
   * @type {Array<any>}
   * @memberof DialpadUser
   */
  experiments?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof DialpadUser
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DialpadUser
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof DialpadUser
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof DialpadUser
   */
  userKey?: string;
}

/**
 * Check if a given object implements the DialpadUser interface.
 */
export function instanceOfDialpadUser(value: object): value is DialpadUser {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function DialpadUserFromJSON(json: any): DialpadUser {
  return DialpadUserFromJSONTyped(json, false);
}

export function DialpadUserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DialpadUser {
  if (json == null) {
    return json;
  }
  return {
    companyId: json['company_id'] == null ? undefined : json['company_id'],
    companyKey: json['company_key'] == null ? undefined : json['company_key'],
    csrPermissions:
      json['csr_permissions'] == null ? undefined : json['csr_permissions'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    dialpadApiKey:
      json['dialpad_api_key'] == null ? undefined : json['dialpad_api_key'],
    dialpadUserId:
      json['dialpad_user_id'] == null ? undefined : json['dialpad_user_id'],
    experiments: json['experiments'] == null ? undefined : json['experiments'],
    id: json['id'],
    key: json['key'],
    userId: json['user_id'] == null ? undefined : json['user_id'],
    userKey: json['user_key'] == null ? undefined : json['user_key'],
  };
}

export function DialpadUserToJSON(value?: DialpadUser | null): any {
  if (value == null) {
    return value;
  }
  return {
    company_id: value['companyId'],
    company_key: value['companyKey'],
    csr_permissions: value['csrPermissions'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    dialpad_api_key: value['dialpadApiKey'],
    dialpad_user_id: value['dialpadUserId'],
    experiments: value['experiments'],
    id: value['id'],
    key: value['key'],
    user_id: value['userId'],
    user_key: value['userKey'],
  };
}
